// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import { OrgUnitSelect, Selects } from './../../components';
import { Filter } from '../../components/hoc';
import { Spoiler } from './../../components/ui';
import Grid, { GridItem } from './../../components/layout/Grid';
import Field from '../../components/card/Field';
const {
  PositionSelect
} = Selects;
const Content = styled(Grid).withConfig({
  displayName: "Filter__Content",
  componentId: "sc-1tum369-0"
})(["padding:16px;"]);
const Buttons = styled(GridItem).withConfig({
  displayName: "Filter__Buttons",
  componentId: "sc-1tum369-1"
})(["margin:0 -10px;& .ant-btn{margin:0 10px;}"]);
const EmployeeFilter = ({
  filter,
  applyFilter,
  cleanFilter
}) => <Spoiler label="Фильтр">
    <Content gutter="16px">
      <Filter cleanFilter={cleanFilter} applyFilter={applyFilter} initialValues={filter}>
        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) => <>
            <GridItem>
              <Field label="ФИО">
                <Input placeholder="Введите ФИО сотрудника" value={values.search} onChange={({
              target: {
                value
              }
            }) => changeValue('search', value)} />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Организация">
                <OrgUnitSelect value={values.nodeId} onChange={value => changeValue('nodeId', value)} />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Должность">
                <PositionSelect value={values.positions} mode="multiple" onChange={(value, selectedOptions) => changeValue('positions', selectedOptions.map(option => option.props.value))} />
              </Field>
            </GridItem>
            <Buttons fullWidth>
              <Button type="primary" onClick={applyFilter}>
                Подтвердить
              </Button>
              <Button type="plain" onClick={cleanFilter}>
                Отменить
              </Button>
            </Buttons>
          </>}
      </Filter>
    </Content>
  </Spoiler>;
export default EmployeeFilter;
